import React from "react";
import {
	Badge,
	Button,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

export const OperativosFilters = ({
	fechaDesde,
	fechaHasta,
	textoBusqueda,
	filtroOperativo,
	onFechaDesdeChange,
	onFechaHastaChange,
	onTextoBusquedaChange,
	onFiltroOperativoChange,
	onAplicarFiltroFechas,
	onLimpiarFiltros,
	onVolver,
	onExportarOperativos,
	exporting,
	cantidadFiltros,
	onToggleFiltros,
}) => (
	<Grid container direction="row" justifyContent="start" alignItems="end" spacing={2} sx={{ px: 2 }}>
		<TextField
			variant="standard"
			label="Fecha desde"
			type="date"
			size="small"
			value={fechaDesde}
			onChange={(event) => onFechaDesdeChange(event.target.value)}
			InputLabelProps={{ shrink: true }}
		/>

		<TextField
			variant="standard"
			label="Fecha hasta"
			type="date"
			size="small"
			value={fechaHasta}
			onChange={(event) => onFechaHastaChange(event.target.value)}
			InputLabelProps={{ shrink: true }}
		/>

		<TextField
			variant="standard"
			label="Buscar parte"
			placeholder="ID, grupo, empresa, delegacion..."
			size="small"
			value={textoBusqueda}
			onChange={(event) => onTextoBusquedaChange(event.target.value)}
		/>

		<FormControl variant="standard" sx={{ minWidth: 170 }}>
			<InputLabel id="filtro-operativo-label">Estado operativo</InputLabel>
			<Select
				labelId="filtro-operativo-label"
				value={filtroOperativo}
				label="Estado operativo"
				onChange={(event) => onFiltroOperativoChange(event.target.value)}
			>
				<MenuItem value="todos">Todos</MenuItem>
				<MenuItem value="no">Pendientes</MenuItem>
				<MenuItem value="si">Operativos</MenuItem>
			</Select>
		</FormControl>

		<Button variant="contained" onClick={onAplicarFiltroFechas}>
			Buscar
		</Button>

		<Button variant="outlined" onClick={onLimpiarFiltros}>
			Limpiar
		</Button>

		<Badge badgeContent={cantidadFiltros} color="primary">
			<Button variant="outlined" onClick={onToggleFiltros}>
				<FilterAltIcon sx={{ fontSize: 20, mr: 0.3, mt: -0.3 }} />
				filtros
			</Button>
		</Badge>

		<Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={onVolver}>
			Volver a cuadrillas
		</Button>

		<Button
			variant="outlined"
			startIcon={<FileDownloadIcon />}
			onClick={onExportarOperativos}
			disabled={exporting}
		>
			{exporting ? "Exportando..." : "Exportar operativos"}
		</Button>
	</Grid>
);
